import {appendFormOnSubmitHandler, findParentForm, submitWithExtraParam} from "./form-utils";

import React from 'react';
import ReactDOM from 'react-dom';

export function loadFormButtons() {
    const formButtonDiv = document.querySelector('.formButtonDiv');
    if (!formButtonDiv) {
        console.error("FormButtonDiv failed to load...");
        return;
    }

    loadLogicToHideLoadingWhenDivAppears(formButtonDiv);

    const {
        disableOnSubmit: disableOnSubmitData,
        progbarPollUrl,
        disableLoadingOverlay
    } = formButtonDiv.dataset;
    const disableOnSubmit = disableOnSubmitData === "false";
    const parentForm = findParentForm(formButtonDiv);

    loadSmartCancelButton();
    applyErrorMsgLabels();

    const formButtons = document.querySelectorAll('.formButton');
    if (formButtons) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const shouldCloseWindow = urlParams.get('shouldCloseWindow');
        formButtons.forEach((btn) => {
            if (btn.value === i18n.common.back && shouldCloseWindow) {
                btn.addEventListener('click', () => {
                    window.close();
                });
            }
        });
    }

    if (parentForm && !disableLoadingOverlay) {
        loadUILoadingLogicForOnSubmit(parentForm);
    }

    if (disableOnSubmit) {
        loadDisableOnSubmitLogic(parentForm, progbarPollUrl);
    }
}

const loadUILoadingLogicForOnSubmit = (form) => {
    appendFormOnSubmitHandler(function() {
        updateFormToLoadingState(form);
        const node = createCenteredNodeDiv();
        form.appendChild(node);
        ReactDOM.render(getAjaxLoadingContainer(), node);
    }, form);
}

export const revertFormFromLoadingState = (form) => {
    form.style.opacity = '1';
    hideLoadingDiv();
    const loadingDivs = document.querySelectorAll('.dynamic-form-loading-div');
    if (loadingDivs) {
        loadingDivs.forEach((loadingDiv) => {
            loadingDiv.style.display = 'none';
        })
    }
}

const updateFormToLoadingState = (form) => {
    form.style.opacity = '0.5';
    form.style.transition = 'all 0.15s ease-in-out';
}

const createCenteredNodeDiv = () => {
    const node = document.createElement('div');
    node.classList.add('dynamic-form-loading-div');
    node.style.position = 'absolute';
    node.style.top = '50%';
    node.style.left = '50%';
    node.style.transform = 'translate(-50%, -50%)';
    return node;
}

const getAjaxLoadingContainer = () => (
    <div>
        <div className="loading-container ex-large in-progress">
            <span className="loading"></span>
            <span className="loading-notch"></span>
            <span className="loading-result"></span>
        </div>
    </div>
);

const loadLogicToHideLoadingWhenDivAppears = (formButtonDiv) => {
    if (formButtonDiv.style.display !== 'none') {
        hideLoadingDiv();
    }

    const observer = new MutationObserver(function(mutations, observer) {
        for (let {type, target} of mutations) {
            hideLoadingDiv();
        }
    });
    observer.observe(formButtonDiv, {attributes: true});
};

const hideLoadingDiv = () => {
    const loadingDiv = document.querySelector('.formButtonLoadingDiv');
    if (loadingDiv) {
        loadingDiv.style.display = 'none';
    }
}

function loadSmartCancelButton() {
    const smartCancelButton = document.querySelector('input[name="CANCEL"]');
    if (smartCancelButton) {
        smartCancelButton.addEventListener('click', function() {
            const parentForm = findParentForm(this);
            submitWithExtraParam(parentForm, 'CANCEL');
        });
    }
}

function applyErrorMsgLabels() {
    const errorMessages = document.querySelectorAll('.errorMsg');
    const errorDiv = document.querySelector('.errorDiv');
    const errorText = document.querySelector('.errorText');

    if (!errorMessages || errorMessages.length === 0 || !errorDiv || !errorText || errorDiv.dataset.hideErrorDiv === 'true') {
        return;
    }

    let content = '';
    for (let i = 0; i < errorMessages.length; i++) {
        const isDisplayed = errorMessages[i].style.display !== 'none';
        if (isDisplayed && errorMessages[i].innerText)
            content += errorMessages[i].innerText + '\n';
    }

    if (!content) {
        return;
    }

    errorDiv.style.display = 'block';
    errorText.innerText = content;
}

function loadDisableOnSubmitLogic(parentForm, progbarPollUrl) {
    if (!parentForm) {
        console.error('Failed to find form for formButtons...');
        return;
    }

    // Disable the save and cancel buttons to prevent double submission.
    appendFormOnSubmitHandler(function() {
        if (parentForm.btnSave)
            parentForm.btnSave.disabled = true;

        if (parentForm.CANCEL)
            parentForm.CANCEL.disabled = true;

        if (progbarPollUrl) {
            const progbarEl = document.querySelector('.PBArea');
            progbarEl.style.display = 'block';
        } else {
            const loadingProgressEl = document.querySelector('.loading-progress');
            loadingProgressEl.style.display = 'block';
        }

        return true;
    }, parentForm);
}

export function hasFormButtons() {
    return document.querySelector('.formButtonDiv');
}